import { buildValidations, validator } from 'ember-cp-validations';

const StakeholderValidations = buildValidations({
  usTaxPayer: [
    validator('ds-error'),
    validator('presence', { presence: true, messageKey: 'generic.required-field.error' }),
  ],
  taxPayerOutsideLegalCountry: [
    validator('ds-error'),
    validator('presence', { presence: true, messageKey: 'generic.required-field.error' }),
  ],
});

export default StakeholderValidations;
